import React from 'react'
import { Spinner, Table } from 'react-bootstrap'
import KycButton from '../../components/form/Button/Button'

interface EuaEnquiryResultsProps {
  apiResponse: {
    exclusiveUsageNumber: string
    ownerName: string
    purchasePrice: number
  }[]
  selectedItems: string[]
  isLoadingPropertyEnquiry: boolean
  handleToggleSelection: (exclusiveUsageNumber: string) => void
  handleProceed: () => void
  handleClose: () => void
}

const EuaEnquiryResults: React.FC<EuaEnquiryResultsProps> = ({
  apiResponse,
  selectedItems,
  isLoadingPropertyEnquiry,
  handleToggleSelection,
  handleProceed,
  handleClose,
}) => {
  return (
    <>
      <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
        {isLoadingPropertyEnquiry && (
          <div className="spinner-container">
            <Spinner
              as="span"
              animation="border"
              variant="dark"
              role="status"
              aria-hidden="true"
            ></Spinner>
            <span> </span>
          </div>
        )}
        <Table
          striped
          bordered
          hover
          style={{ width: '100%', marginTop: '20px' }}
        >
          <thead>
            <tr>
              <th
                className="labelMargin colBorderSpliter"
                style={{
                  width: '200px',
                  whiteSpace: 'nowrap',
                  backgroundColor: 'rgb(12, 135, 169)',
                }}
              >
                <span className="detailLabel" style={{ color: 'white' }}>
                  Exclusive Usage Number
                </span>
              </th>
              <th
                className="labelMargin colBorderSpliter"
                style={{ backgroundColor: 'rgb(12, 135, 169)' }}
              >
                <span className="detailLabel" style={{ color: 'white' }}>
                  Owner Name
                </span>
              </th>
              <th
                className="labelMargin colBorderSpliter"
                style={{ backgroundColor: 'rgb(12, 135, 169)' }}
              >
                <span className="detailLabel" style={{ color: 'white' }}>
                  Purchase Price
                </span>
              </th>
            </tr>
          </thead>
          <tbody style={{ cursor: 'pointer' }}>
            {apiResponse.map((item: any, index: number) => (
              <tr
                key={index}
                onClick={() => handleToggleSelection(item.exclusiveUsageNumber)}
                className={`TableHover-eua ${
                  selectedItems.includes(item.exclusiveUsageNumber)
                    ? 'selected-row-eua'
                    : ''
                }`}
              >
                <td
                  className={`labelMargin colBorderSpliter border ${
                    selectedItems.includes(item.exclusiveUsageNumber)
                      ? 'selected-row-eua'
                      : ''
                  }`}
                >
                  {item.exclusiveUsageNumber}
                </td>
                <td
                  className={`labelMargin colBorderSpliter border ${
                    selectedItems.includes(item.exclusiveUsageNumber)
                      ? 'selected-row-eua'
                      : ''
                  }`}
                >
                  {item.ownerName}
                </td>
                <td
                  className={`labelMargin colBorderSpliter border ${
                    selectedItems.includes(item.exclusiveUsageNumber)
                      ? 'selected-row-eua'
                      : ''
                  }`}
                >
                  {item.purchasePrice}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <div className="footer-btns">
        <KycButton
          className="m-l-10"
          onClick={() => {
            if (selectedItems.length === 0 || isLoadingPropertyEnquiry) {
              alert(
                'Please select a unit or multiple units to complete the EUA enquiry.',
              )
            } else {
              handleProceed()
            }
          }}
          variant={'outline-primary'}
          size="lg"
        >
          Proceed
        </KycButton>
        <KycButton
          className="m-l-10"
          onClick={handleClose}
          variant={'outline-primary'}
          size="lg"
        >
          Close
        </KycButton>
      </div>
    </>
  )
}

export default EuaEnquiryResults
